import { useCallback, useState } from 'react'

interface IUseHandleBlur {
  cb: () => void
}

export const useHandleBlur = ({ cb }: IUseHandleBlur) => {
  /** -------------------- Variables ----------------------- */
  const [canBlur, setCanBlur] = useState(true)

  /** -------------------- Methods ----------------------- */
  const handleMouseOver = useCallback(() => {
    setCanBlur(false)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setCanBlur(true)
  }, [])

  const handleBlur = useCallback(() => {
    if (canBlur) {
      cb()
    }
  }, [canBlur, cb])

  return { handleMouseOver, handleMouseLeave, handleBlur }
}
